import { MarketDetailsContainer } from '@/features/sparklend/market-details/MarketDetailsContainer'

export function MarketDetails() {
  return <MarketDetailsContainer />
}
